import {
    TOGGLE_FILTERS_FOR_WEB,
    TOGGLE_PRIZE_BOX_FOR_WEB,
    TOGGLE_SORT_BY_FOR_WEB,
    TOGGLE_PRIZE_BOX_FOR_MOBILE,
    TOGGLE_CLUB_FILTER_FOR_WEB,
    TOGGLE_SEARCH_FOR_BOTH,
    APPLY_SEARCH,
    APPLY_PRIZE,
    APPLY_SORT_BY,
    APPLY_CLUB,
    RESET_TEAM_FILTER,
    RESET_FILTER,
    RESET_ALL_FILTER,
    RESET_SKILL_FILTER,
    APPLY_PLAYER_SORT,
    TOGGLE_SORT_BY_FOR_PLAYER_LIST
} from './../constants/action-types';

export function toggleFilterWeb() {
    return {
        type: TOGGLE_FILTERS_FOR_WEB,
        payload: null
    };
}

export function togglePrizeBoxWeb() {
    return {
        type: TOGGLE_PRIZE_BOX_FOR_WEB,
        payload: null
    };
}

export function toggleSortByBoxWeb() {
    return {
        type: TOGGLE_SORT_BY_FOR_WEB,
        payload: null
    };
}

export function toggleSortByPlayerList() {
    return {
        type: TOGGLE_SORT_BY_FOR_PLAYER_LIST,
        payload: null
    };
}

export function toggleClubBoxWeb() {
    return {
        type: TOGGLE_CLUB_FILTER_FOR_WEB,
        payload: null
    };
}

export function togglePrizeBoxMobile() {
    return {
        type: TOGGLE_PRIZE_BOX_FOR_MOBILE,
        payload: null
    };
}

export function toggleSearchBoxBoth(bool) {
    return {
        type: TOGGLE_SEARCH_FOR_BOTH,
        payload: bool
    };
}

export function applySearchBoth(string) {
    return {
        type: APPLY_SEARCH,
        payload: string
    };
}

export function applyPrizeBoth(priceID) {
    return {
        type: APPLY_PRIZE,
        payload: priceID
    };
}

export function applySortPlayer(ele) {
    return {
        type: APPLY_PLAYER_SORT,
        payload: ele
    };
}

export function applySortByBoth(sortOption) {
    return {
        type: APPLY_SORT_BY,
        payload: sortOption
    };
}

export function applyClubBoth(teamID) {
    return {
        type: APPLY_CLUB,
        payload: teamID
    };
}

export function resetTeamFilter() {
    return {
        type: RESET_TEAM_FILTER,
        payload: null
    };
}

export function resetFilter() {
    return {
        type: RESET_FILTER,
        payload: null
    };
} export function resetAllFilters() {
    return {
        type: RESET_ALL_FILTER,
        payload: null
    };
}

export function triggerResetSkillsFilter() {
    return {
        type: RESET_SKILL_FILTER,
    };
}


// WEBPACK FOOTER //
// ./src/actions/FilterActions.js